import axios from "./axiosInstance";
import {DataJob} from "../types/jobDataTypes";
import {createJobObject} from "../utils/utils";
import {FormJob} from "../types/jobTypes";

export const fetchOptionsforNewJob= async (idEventForNewJob: string) => {
    try {
        const response = await axios.get(process.env.REACT_APP_BASE_URL + `/match/optionsJob/${idEventForNewJob}`);
        return response.data;
    }catch (error) {
        console.error("Failed to fetch data:", error);
        return undefined;
    }
}

export const startJob = async (jobId: string) => {
    const response = await axios.post(process.env.REACT_APP_BASE_URL + `/match/startJob`, {idJob: jobId});
    return response.status;
}

export const stopJob = async (jobId: string) => {
    const response = await axios.post(process.env.REACT_APP_BASE_URL + `/match/stopJob`, {idJob: jobId});
    return response.status;
}

export async function createStartJob(job: FormJob){
    const newJob = await axios.post(process.env.REACT_APP_BASE_URL + `/job`, job);
    return newJob.data
    //return await startJob(newJob.id);
}

export async function updateJob(job: FormJob){
    const updateJob = await axios.put(process.env.REACT_APP_BASE_URL + `/job/${job.id}`, job);
    return updateJob.data
    //return await startJob(newJob.id);
}

export async function getJobById(jobId: string): Promise<FormJob>{
    const job = await axios.get(process.env.REACT_APP_BASE_URL + `/job/${jobId}`);
    return job.data
}

export async function deleteJobClips(jobId: string){
    const response = await axios.delete(process.env.REACT_APP_BASE_URL + `/job/${jobId}/deleteAllClips`,);
    return response.status;
}

export const getJobOptions= async (eventId: string) => {
    try {
        const response = await axios.get(process.env.REACT_APP_BASE_URL + `/job/formOptions/${eventId}`);
        return response.data;
    }catch (error) {
        console.error("Failed to fetch data:", error);
        return undefined;
    }
}

export const getJobGroupByEvent= async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BASE_URL + '/job/jobGroupByEvent');
        return response.data;
    }catch (error) {
        console.error("Failed to fetch data:", error);
        return undefined;
    }
}

export async function getPresetConfigs(){
    try{
        const response = await axios.get(process.env.REACT_APP_BASE_URL + `/job/getPresetConfig`);
        return response.data;
    }catch (error) {
        console.error("Failed to fetch PresetConfigs:", error);
    }
}